<template>
    <div>
        <vue-headful
                     title="Ponderosa Software | Datenschutz"
                     description="Datenschutzerklärung nach der EU-DSGVO für die Ponderosa Software"
        />
        <md-card md-with-hover>
            <md-ripple>
                <md-card-header v-if="runMode != 'modal'">
                    <div class="md-title">Datenschutzerklärung nach der EU-DSGVO</div>
                </md-card-header>

                <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                I. Name und Anschrift des Verantwortlichen
                            </md-subheader>
                            <p class="md-body-1">
                                Der Verantwortliche im Sinne der Datenschutz-Grundverordnung und anderer nationaler
                                Datenschutzgesetze der Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher
                                Bestimmungen ist die:
                            </p>
                            <table border="0" cellpadding="0" cellspacing="0" class="contact-table">
                                <tr>
                                    <td colspan="5"><b>Ponderosa Software UG</b><br/>(haftungsbeschränkt)</td>
                                </tr>
                                <tr>
                                    <td>Bernburger Straße 27</td>
                                    <td class="table-space-middle"></td>
                                    <td>Telefon:</td>
                                    <td class="table-space-right"></td>
                                    <td>+49 177 2358270</td>
                                </tr>
                                <tr>
                                    <td>06108 Halle (Saale)</td>
                                    <td class="table-space-middle"></td>
                                    <td>E-Mail:</td>
                                    <td class="table-space-right"></td>
                                    <td>info@ponderosa-software.de</td>
                                </tr>
                                <tr>
                                    <td>Deutschland</td>
                                    <td class="table-space-middle"></td>
                                    <td>Webseite:</td>
                                    <td class="table-space-right"></td>
                                    <td>www.ponderosa-software.de</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                II. Name und Anschrift des Datenschutzbeauftragten
                            </md-subheader>
                            <p class="md-body-1">
                                Der Datenschutzbeauftragte des Verantwortlichen ist: <b>Falk Huth</b>
                            </p>
                            <p class="md-body-1">
                                Er ist unter der Adresse und unter den Kontaktdaten des Verantwortlichen
                                persönlich erreichbar.
                            </p>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                III. Allgemeines zur Datenverarbeitung
                            </md-subheader>
                            <p class="md-body-2">
                                1. Umfang der Verarbeitung personenbezogener Daten
                            </p>
                            <p class="md-body-1">
                                Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies
                                zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen
                                erforderlich ist. Die Verarbeitung personenbezogener Daten unserer Nutzer erfolgt
                                regelmäßig nur nach Einwilligung des Nutzers. Eine Ausnahme gilt in solchen Fällen,
                                in denen eine vorherige Einholung einer Einwilligung aus tatsächlichen Gründen nicht
                                möglich ist und die Verarbeitung der Daten durch gesetzliche Vorschriften gestattet ist.
                            </p>
                            <p class="md-body-2">
                                2. Rechtsgrundlage für die Verarbeitung personenbezogener Daten
                            </p>
                            <p class="md-body-1">
                                Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der
                                betroffenen Person einholen, dient Art. 6 Abs. 1 lit. a EU-Datenschutzgrundverordnung
                                (DSGVO) als Rechtsgrundlage.
                            </p>
                            <p class="md-body-1">
                                Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung eines Vertrages,
                                dessen Vertragspartei die betroffene Person ist, erforderlich ist, dient Art. 6 Abs. 1
                                lit. b DSGVO als Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur
                                Durchführung vorvertraglicher Maßnahmen erforderlich sind.
                            </p>
                            <p class="md-body-1">
                                Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer rechtlichen
                                Verpflichtung erforderlich ist, der unser Unternehmen unterliegt, dient Art. 6 Abs. 1
                                lit. c DSGVO als Rechtsgrundlage.
                            </p>
                            <p class="md-body-1">
                                Für den Fall, dass lebenswichtige Interessen der betroffenen Person oder einer anderen
                                natürlichen Person eine Verarbeitung personenbezogener Daten erforderlich machen, dient
                                Art. 6 Abs. 1 lit. d DSGVO als Rechtsgrundlage.
                            </p>
                            <p class="md-body-1">
                                Ist die Verarbeitung zur Wahrung eines berechtigten Interesses unseres Unternehmens
                                oder eines Dritten erforderlich und überwiegen die Interessen, Grundrechte und
                                Grundfreiheiten des Betroffenen das erstgenannte Interesse nicht, so dient Art. 6
                                Abs. 1 lit. f DSGVO als Rechtsgrundlage für die Verarbeitung.
                            </p>
                            <p class="md-body-2">
                                3. Datenlöschung und Speicherdauer
                            </p>
                            <p class="md-body-1">
                                Die personenbezogenen Daten der betroffenen Person werden gelöscht oder gesperrt,
                                sobald der Zweck der Speicherung entfällt. Eine Speicherung kann darüber hinaus
                                erfolgen, wenn dies durch den europäischen oder nationalen Gesetzgeber in
                                unionsrechtlichen Verordnungen, Gesetzen oder sonstigen Vorschriften, denen der
                                Verantwortliche unterliegt, vorgesehen wurde. Eine Sperrung oder Löschung der Daten
                                erfolgt auch dann, wenn eine durch die genannten Normen vorgeschriebene Speicherfrist
                                abläuft, es sei denn, dass eine Erforderlichkeit zur weiteren Speicherung der Daten für
                                einen Vertragsabschluss oder eine Vertragserfüllung besteht.
                            </p>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                IV. Bereitstellung der Website und Erstellung von Logfiles
                            </md-subheader>
                            <p class="md-body-2">
                                1. Beschreibung und Umfang der Datenverarbeitung
                            </p>
                            <p class="md-body-1">
                                Bei jedem Aufruf unserer Internetseite erfasst unser System automatisiert Daten und
                                Informationen vom Computersystem des aufrufenden Rechners.
                            </p>
                            <p class="md-body-1">
                                Folgende Daten werden hierbei erhoben:
                            </p>
                            <ul style="list-style-type: none;" class="md-body-1">
                                <li v-for="log_info in log_infos"
                                    v-bind:key="log_info">{{log_info}}</li>
                            </ul>
                            <p class="md-body-1" v-if="log_option_1">
                                Die Daten werden ebenfalls in den Logfiles unseres Systems gespeichert. Eine
                                Speicherung dieser Daten zusammen mit anderen personenbezogenen Daten des Nutzers
                                findet nicht statt.
                            </p>
                            <p class="md-body-1" v-if="log_option_2">
                                Die Daten werden ebenfalls in den Logfiles unseres Systems gespeichert. Nicht hiervon
                                betroffen sind die IP-Adressen des Nutzers oder andere Daten, die die Zuordnung der
                                Daten zu einem Nutzer ermöglichen. Eine Speicherung dieser Daten zusammen mit anderen
                                personenbezogenen Daten des Nutzers findet nicht statt.
                            </p>
                            <p class="md-body-2">
                                2. Rechtsgrundlage für die Datenverarbeitung
                            </p>
                            <p class="md-body-1" v-if="log_contains_ip">
                                Rechtsgrundlage für die vorübergehende Speicherung der Daten und der Logfiles ist
                                Art. 6 Abs. 1 lit. f DSGVO.
                            </p>
                            <p class="md-body-1" v-if="!log_contains_ip">
                                Rechtsgrundlage für die vorübergehende Speicherung der Daten ist Art. 6 Abs. 1
                                lit. f DSGVO.
                            </p>
                            <p class="md-body-2">
                                3. Zweck der Datenverarbeitung
                            </p>
                            <p class="md-body-1">
                                Die vorübergehende Speicherung der IP-Adresse durch das System ist notwendig, um eine
                                Auslieferung der Website an den Rechner des Nutzers zu ermöglichen. Hierfür muss die
                                IP-Adresse des Nutzers für die Dauer der Sitzung gespeichert bleiben.
                            </p>
                            <p class="md-body-1" v-if="log_contains_ip && !log_ip_only_for_defense">
                                Die Speicherung in Logfiles erfolgt, um die Funktionsfähigkeit der Website
                                sicherzustellen. Zudem dienen uns die Daten zur Optimierung der Website und zur
                                Sicherstellung der Sicherheit unserer informationstechnischen Systeme. Eine Auswertung
                                der Daten zu Marketingzwecken findet in diesem Zusammenhang nicht statt.
                            </p>
                            <p class="md-body-1" v-if="log_contains_ip && log_ip_only_for_defense">
                                Die IP-Adressen der Nutzer werden nur zur Erkennung und Abwehr von Angriffen
                                in Logfiles gespeichert. Eine weitere Auswertung erfolgt nicht.
                            </p>
                            <p class="md-body-1">
                                In diesen Zwecken liegt auch unser berechtigtes Interesse an der Datenverarbeitung
                                nach Art. 6 Abs. 1 lit. f DSGVO.
                            </p>
                            <p class="md-body-2">
                                4.	Dauer der Speicherung
                            </p>
                            <p class="md-body-1">
                                Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung
                                nicht mehr erforderlich sind. Im Falle der Erfassung der Daten zur Bereitstellung der
                                Website ist dies der Fall, wenn die jeweilige Sitzung beendet ist.
                            </p>
                            <p class="md-body-1" v-if="log_contains_ip">
                                Im Falle der Speicherung der Daten in Logfiles ist dies {{log_latest_deleting}}
                                der Fall. Eine darüberhinausgehende Speicherung ist möglich. In diesem Fall werden die
                                IP-Adressen der Nutzer gelöscht oder verfremdet, sodass eine Zuordnung des aufrufenden
                                Clients nicht mehr möglich ist.
                            </p>
                            <p class="md-body-2">
                                5.	Widerspruchs- und Beseitigungsmöglichkeit
                            </p>
                            <p class="md-body-1">
                                Die Erfassung der Daten zur Bereitstellung der Website und die Speicherung der Daten
                                in Logfiles ist für den Betrieb der Internetseite zwingend erforderlich. Es besteht
                                folglich seitens des Nutzers keine Widerspruchsmöglichkeit.
                            </p>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                V. Verwendung von Cookies
                            </md-subheader>
                            <p class="md-body-2">
                                a) Beschreibung und Umfang der Datenverarbeitung
                            </p>
                            <p class="md-body-1" v-if="cookies_not_necessary_used || cookies_necessary_used">
                                Unsere Internetseite verwendet Cookies. Bei Cookies handelt es sich um Textdateien,
                                die im Internetbrowser bzw. vom Internetbrowser auf dem Computersystem des Nutzers
                                gespeichert werden. Ruft ein Nutzer eine Website auf, so kann ein Cookie auf dem
                                Betriebssystem des Nutzers gespeichert werden. Dieser Cookie enthält eine
                                charakteristische Zeichenfolge, die eine eindeutige Identifizierung des Browsers beim
                                erneuten Aufrufen der Internetseite ermöglicht.
                            </p>
                            <p v-else>
                                Unsere Internetseite verwendet keine Cookies.
                            </p>
                            <p class="md-body-1" v-if="cookies_necessary_used">
                                Wir setzen Cookies ein, um unsere Internetseite nutzerfreundlicher zu gestalten. Einige
                                Elemente unserer Internetseite erfordern es, dass der aufrufende Browser auch nach
                                einem Seitenwechsel identifiziert werden kann.
                            </p>
                            <p class="md-body-1" v-if="cookies_necessary_used">
                                In den Cookies werden dabei folgende Daten gespeichert und übermittelt:
                            </p>
                            <ul style="list-style-type: none;" class="md-body-1" v-if="cookies_necessary_used">
                                <li v-for="cookies_necessary_entry in cookies_necessary_entries"
                                    v-bind:key="cookies_necessary_entry">{{cookies_necessary_entry}}</li>
                            </ul>
                            <p class="md-body-1" v-if="cookies_not_necessary_used">
                                Wir verwenden auf unserer Internetseite darüber hinaus Cookies, die eine Analyse des
                                Surfverhaltens der Nutzer ermöglichen.
                            </p>
                            <p class="md-body-1" v-if="cookies_not_necessary_used">
                                Auf diese Weise können folgende Daten übermittelt werden:
                            </p>
                            <ul style="list-style-type: none;" class="md-body-1" v-if="cookies_not_necessary_used">
                                <li v-for="cookies_not_necessary_entry in cookies_not_necessary_entries"
                                    v-bind:key="cookies_not_necessary_entry">{{cookies_not_necessary_entry}}</li>
                            </ul>
                            <p class="md-body-1" v-if="cookies_not_necessary_used && !cookies_not_necessary_accepted">
                                Die auf diese Weise erhobenen Daten der Nutzer werden durch technische Vorkehrungen
                                pseudonymisiert. Daher ist eine Zuordnung der Daten zum aufrufenden Nutzer nicht mehr
                                möglich. Die Daten werden nicht gemeinsam mit sonstigen personenbezogenen Daten der
                                Nutzer gespeichert.
                            </p>
                            <p class="md-body-1" v-if="cookies_not_necessary_used && !cookies_not_necessary_accepted">
                                Beim Aufruf unserer Internetseite werden die Nutzer durch einen Infobanner über die
                                Verwendung von Cookies zu Analysezwecken informiert und auf diese Datenschutzerklärung
                                verwiesen. Es erfolgt in diesem Zusammenhang auch ein Hinweis darauf, wie die
                                Speicherung von Cookies in den Browsereinstellungen unterbunden werden kann.
                            </p>
                            <p class="md-body-1" v-if="cookies_not_necessary_used && cookies_not_necessary_accepted">
                                Beim Aufruf unserer Internetseite wird der Nutzer über die Verwendung von Cookies zu
                                Analysezwecken informiert und seine Einwilligung zur Verarbeitung der in diesem
                                Zusammenhang verwendeten personenbezogenen Daten eingeholt. In diesem Zusammenhang
                                erfolgt auch ein Hinweis auf diese Datenschutzerklärung.
                            </p>
                            <p class="md-body-2">
                                b) Rechtsgrundlage für die Datenverarbeitung
                            </p>
                            <p class="md-body-1" v-if="!cookies_not_necessary_used && !cookies_necessary_used">
                                nicht relevant
                            </p>
                            <p class="md-body-1" v-if="cookies_necessary_used && (!cookies_not_necessary_used || !cookies_not_necessary_accepted)">
                                Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten unter Verwendung von
                                Cookies ist Art. 6 Abs. 1 lit. f DSGVO.
                            </p>
                            <p class="md-body-1" v-if="cookies_necessary_used && cookies_not_necessary_used && cookies_not_necessary_accepted">
                                Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten unter Verwendung
                                technisch notweniger Cookies ist Art. 6 Abs. 1 lit. f DSGVO.
                            </p>
                            <p class="md-body-1" v-if="cookies_not_necessary_used && cookies_not_necessary_accepted">
                                Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten unter Verwendung
                                von Cookies zu Analysezwecken ist bei Vorliegen einer diesbezüglichen Einwilligung
                                des Nutzers Art. 6 Abs. 1 lit. a DSGVO.
                            </p>
                            <p class="md-body-2">
                                c) Zweck der Datenverarbeitung
                            </p>
                            <p class="md-body-1" v-if="cookies_necessary_used">
                                Der Zweck der Verwendung technisch notwendiger Cookies ist, die Nutzung von Websites
                                für die Nutzer zu vereinfachen. Einige Funktionen unserer Internetseite können ohne
                                den Einsatz von Cookies nicht angeboten werden. Für diese ist es erforderlich, dass der
                                Browser auch nach einem Seitenwechsel wiedererkannt wird.
                            </p>
                            <p class="md-body-1" v-if="cookies_necessary_used">
                                Für folgende Anwendungen benötigen wir Cookies:
                            </p>
                            <ul style="list-style-type: none;" class="md-body-1" v-if="cookies_necessary_used">
                                <li v-for="cookies_application in cookies_applications"
                                    v-bind:key="cookies_application">
                                    {{cookies_application}}
                                </li>
                            </ul>
                            <p class="md-body-1" v-if="cookies_necessary_used">
                                Die durch technisch notwendige Cookies erhobenen Nutzerdaten werden nicht zur
                                Erstellung von Nutzerprofilen verwendet.
                            </p>
                            <p class="md-body-1" v-if="cookies_not_necessary_used">
                                Die Verwendung der Analyse-Cookies erfolgt zu dem Zweck, die Qualität unserer Website
                                und ihre Inhalte zu verbessern. Durch die Analyse-Cookies erfahren wir, wie die Website
                                genutzt wird und können so unser Angebot stetig optimieren.
                            </p>
                            <p class="md-body-1" v-if="cookies_not_necessary_used">
                                {{cookies_not_necessary_reason}}
                            </p>
                            <p class="md-body-1" v-if="cookies_not_necessary_used || cookies_necessary_used">
                                In diesen Zwecken liegt auch unser berechtigtes Interesse in der Verarbeitung der
                                personenbezogenen Daten nach Art. 6 Abs. 1 lit. f DSGVO.
                            </p>
                            <p v-else>
                                nicht relevant
                            </p>
                            <p class="md-body-2">
                                d) Dauer der Speicherung, Widerspruchs- und Beseitigungsmöglichkeit
                            </p>
                            <p class="md-body-1" v-if="cookies_not_necessary_used || cookies_necessary_used">
                                Cookies werden auf dem Rechner des Nutzers gespeichert und von diesem an unserer Seite
                                übermittelt. Daher haben Sie als Nutzer auch die volle Kontrolle über die Verwendung
                                von Cookies. Durch eine Änderung der Einstellungen in Ihrem Internetbrowser können Sie
                                die Übertragung von Cookies deaktivieren oder einschränken. Bereits gespeicherte
                                Cookies können jederzeit gelöscht werden. Dies kann auch automatisiert erfolgen.
                                Werden Cookies für unsere Website deaktiviert, können möglicherweise nicht mehr alle
                                Funktionen der Website vollumfänglich genutzt werden.
                            </p>
                            <p v-else>
                                nicht relevant
                            </p>
                            <p class="md-body-1" v-if="cookies_flash_used">
                                Die Übermittlung von Flash-Cookies lässt sich nicht über die Einstellungen des
                                Browsers, jedoch durch Änderungen der Einstellung des Flash Players unterbinden.
                            </p>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                VI. Newsletter
                            </md-subheader>
                            <p class="md-body-2">
                                1. Beschreibung und Umfang der Datenverarbeitung
                            </p>
                            <p v-if="newsletter_not_used">
                                Auf unserer Internetseite wird keine Newsletter-Funktionalität angeboten.
                            </p>
                            <p class="md-body-1" v-if="newsletter_website_registering && !newsletter_not_used">
                                Auf unserer Internetseite besteht die Möglichkeit einen kostenfreien Newsletter zu
                                abonnieren. Dabei werden bei der Anmeldung zum Newsletter die Daten aus der
                                Eingabemaske an uns übermittelt.
                            </p>
                            <ul style="list-style-type: none;" class="md-body-1" v-if="newsletter_website_registering && !newsletter_not_used">
                                <li v-for="newsletter_form_data_entry in newsletter_form_data_entries"
                                    v-bind:key="newsletter_form_data_entry">
                                    {{newsletter_form_data_entry}}
                                </li>
                            </ul>
                            <p class="md-body-1" v-if="newsletter_website_registering && !newsletter_not_used">
                                Zudem werden folgende Daten bei der Anmeldung erhoben:
                            </p>
                            <ul style="list-style-type: none;" class="md-body-1" v-if="newsletter_website_registering && !newsletter_not_used">
                                <li v-for="newsletter_registration_data_entry in newsletter_registration_data_entries"
                                    v-bind:key="newsletter_registration_data_entry">
                                    {{newsletter_registration_data_entry}}
                                </li>
                            </ul>
                            <p class="md-body-1" v-if="newsletter_website_registering && !newsletter_not_used">
                                Für die Verarbeitung der Daten wird im Rahmen des Anmeldevorgangs Ihre Einwilligung
                                eingeholt und auf diese Datenschutzerklärung verwiesen.
                            </p>
                            <p class="md-body-1" v-if="newsletter_buying_products && !newsletter_not_used">
                                Wenn Sie auf unserer Internetseite Waren oder Dienstleistungen erwerben und hierbei
                                Ihre E-Mail-Adresse hinterlegen, kann diese in der Folge durch uns für den Versand
                                eines Newsletters verwendet werden. In einem solchen Fall wird über den Newsletter
                                ausschließlich Direktwerbung für eigene ähnliche Waren oder Dienstleistungen versendet.
                            </p>
                            <p class="md-body-1" v-if="!newsletter_not_used">
                                Es erfolgt im Zusammenhang mit der Datenverarbeitung für den Versand von Newslettern
                                keine Weitergabe der Daten an Dritte. Die Daten werden ausschließlich für den Versand
                                des Newsletters verwendet.
                            </p>
                            <p class="md-body-2">
                                2. Rechtsgrundlage für die Datenverarbeitung
                            </p>
                            <p class="md-body-1" v-if="newsletter_website_registering && !newsletter_not_used">
                                Rechtsgrundlage für die Verarbeitung der Daten nach Anmeldung zum Newsletters durch
                                den Nutzer ist bei Vorliegen einer Einwilligung des Nutzers Art. 6 Abs. 1 lit. a DSGVO.
                            </p>
                            <p class="md-body-1" v-if="newsletter_buying_products && !newsletter_not_used">
                                Rechtsgrundlage für den Versand des Newsletters infolge des Verkaufs von Waren oder
                                Dienstleistungen ist § 7 Abs. 3 UWG.
                            </p>
                            <p class="md-body-1" v-if="newsletter_not_used || (!newsletter_buying_products && !newsletter_website_registering)">
                                nicht relevant
                            </p>
                            <p class="md-body-2">
                                3. Zweck der Datenverarbeitung
                            </p>
                            <p class="md-body-1" v-if="newsletter_not_used">
                                nicht relevant
                            </p>
                            <p class="md-body-1" v-else>
                                Die Erhebung der E-Mail-Adresse des Nutzers dient dazu, den Newsletter zuzustellen.
                            </p>
                            <p class="md-body-1" v-if="newsletter_website_registering && !newsletter_not_used">
                                Die Erhebung sonstiger personenbezogener Daten im Rahmen des Anmeldevorgangs dient
                                dazu, einen Missbrauch der Dienste oder der verwendeten E-Mail-Adresse zu verhindern.
                            </p>
                            <p class="md-body-2">
                                4. Dauer der Speicherung
                            </p>
                            <p class="md-body-1" v-if="newsletter_not_used">
                                nicht relevant
                            </p>
                            <p class="md-body-1" v-else>
                                Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung
                                nicht mehr erforderlich sind. Die E-Mail-Adresse des Nutzers wird demnach solange
                                gespeichert, wie das Abonnement des Newsletters aktiv ist.
                            </p>
                            <p class="md-body-1" v-if="newsletter_website_registering && !newsletter_not_used">
                                Die sonstigen im Rahmen des Anmeldevorgangs erhobenen personenbezogenen Daten werden
                                in der Regel nach einer Frist von sieben Tagen gelöscht.
                            </p>
                            <p class="md-body-2">
                                5. Widerspruchs- und Beseitigungsmöglichkeit
                            </p>
                            <p class="md-body-1" v-if="newsletter_not_used">
                                nicht relevant
                            </p>
                            <p class="md-body-1" v-else>
                                Das Abonnement des Newsletters kann durch den betroffenen Nutzer jederzeit gekündigt
                                werden. Zu diesem Zweck findet sich in jedem Newsletter ein entsprechender Link.
                            </p>
                            <p class="md-body-1" v-if="newsletter_website_registering && !newsletter_not_used">
                                Hierdurch wird ebenfalls ein Widerruf der Einwilligung der Speicherung der während des
                                Anmeldevorgangs erhobenen personenbezogenen Daten ermöglicht.
                            </p>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                VII. Registrierung
                            </md-subheader>
                            <p class="md-body-2">
                                1. Beschreibung und Umfang der Datenverarbeitung
                            </p>
                            <p class="md-body-1" v-if="registration_enabled">
                                Auf unserer Internetseite bieten wir Nutzern die Möglichkeit, sich unter Angabe
                                personenbezogener Daten zu registrieren. Die Daten werden dabei in eine Eingabemaske
                                eingegeben und an uns übermittelt und gespeichert. Eine Weitergabe der Daten an Dritte
                                findet nicht statt. Folgende Daten werden im Rahmen des Registrierungsprozesses erhoben:
                            </p>
                            <p class="md-body-1" v-else>
                                Auf unserer Internetseite ist es Nutzern nicht möglich, sich unter Angabe
                                personenbezogener Daten zu registrieren.
                            </p>
                            <ul style="list-style-type: none;" class="md-body-1" v-if="registration_enabled">
                                <li v-for="registration_data_entry in registration_data_entries"
                                    v-bind:key="registration_data_entry">
                                    {{registration_data_entry}}
                                </li>
                            </ul>
                            <p class="md-body-1" v-if="registration_enabled">
                                Im Zeitpunkt der Registrierung werden zudem folgende Daten gespeichert:
                            </p>
                            <ul style="list-style-type: none;" class="md-body-1" v-if="registration_enabled">
                                <li v-for="registration_process_entry in registration_process_entries"
                                    v-bind:key="registration_process_entry">
                                    {{registration_process_entry}}
                                </li>
                            </ul>
                            <p class="md-body-1" v-if="registration_enabled">
                                Im Rahmen des Registrierungsprozesses wird eine Einwilligung des Nutzers zur
                                Verarbeitung dieser Daten eingeholt.
                            </p>
                            <p class="md-body-2">
                                2. Rechtsgrundlage für die Datenverarbeitung
                            </p>
                            <p class="md-body-1" v-if="registration_enabled">
                                Rechtsgrundlage für die Verarbeitung der Daten ist bei Vorliegen einer Einwilligung des
                                Nutzers Art. 6 Abs. 1 lit. a DSGVO.
                            </p>
                            <p class="md-body-1" v-else>
                                nicht relevant
                            </p>
                            <p class="md-body-1" v-if="registration_for_contract_needs_set && registration_enabled">
                                Dient die Registrierung der Erfüllung eines Vertrages, dessen Vertragspartei der Nutzer
                                ist oder der Durchführung vorvertraglicher Maßnahmen, so ist zusätzliche Rechtsgrundlage
                                für die Verarbeitung der Daten Art. 6 Abs. 1 lit. b DSGVO.
                            </p>
                            <p class="md-body-2">
                                3. Zweck der Datenverarbeitung
                            </p>
                            <p class="md-body-1" v-if="registration_enabled">
                                Eine Registrierung des Nutzers ist für das Bereithalten bestimmter Inhalte und
                                Leistungen auf unserer Website erforderlich.
                            </p>
                            <p class="md-body-1" v-else>
                                nicht relevant
                            </p>
                            <p class="md-body-1" v-if="registration_enabled">
                                {{registration_without_contract_details}}
                            </p>
                            <p class="md-body-1" v-if="registration_enabled">
                                Eine Registrierung des Nutzers ist zur Erfüllung eines Vertrages mit dem Nutzer oder zur Durchführung vorvertraglicher Maßnahmen erforderlich.
                            </p>
                            <p class="md-body-1" v-if="registration_enabled">
                                {{registration_for_contract_needs_details}}
                            </p>
                            <p class="md-body-1" v-if="registration_enabled">
                                {{registration_for_contract_needs_laws}}
                            </p>
                            <p class="md-body-2">
                                4. Dauer der Speicherung
                            </p>
                            <p class="md-body-1" v-if="registration_enabled">
                                Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung
                                nicht mehr erforderlich sind.
                            </p>
                            <p class="md-body-1" v-else>
                                nicht relevant
                            </p>
                            <p class="md-body-1" v-if="registration_without_contract_set && registration_enabled">
                                Dies ist für die während des Registrierungsvorgangs erhobenen Daten der Fall, wenn die
                                Registrierung auf unserer Internetseite aufgehoben oder abgeändert wird.
                            </p>
                            <p class="md-body-1" v-if="registration_for_contract_needs_set && registration_enabled">
                                Dies ist für die während des Registrierungsvorgangs zur Erfüllung eines Vertrags oder
                                zur Durchführung vorvertraglicher Maßnahmen dann der Fall, wenn die Daten für die
                                Durchführung des Vertrages nicht mehr erforderlich sind. Auch nach Abschluss des
                                Vertrags kann eine Erforderlichkeit, personenbezogene Daten des Vertragspartners zu
                                speichern, bestehen, um vertraglichen oder gesetzlichen Verpflichtungen nachzukommen.
                            </p>
                            <p class="md-body-1" v-if="registration_for_contract_needs_set && registration_enabled">
                                {{registration_for_finance_needs_laws}}
                            </p>
                            <p class="md-body-2">
                                5. Widerspruchs- und Beseitigungsmöglichkeit
                            </p>
                            <p class="md-body-1" v-if="registration_enabled">
                                Als Nutzer haben sie jederzeit die Möglichkeit, die Registrierung aufzulösen. Die über
                                Sie gespeicherten Daten können Sie jederzeit abändern lassen.
                            </p>
                            <p class="md-body-1" v-else>
                                nicht relevant
                            </p>
                            <p class="md-body-1" v-if="registration_enabled">
                                {{registration_deleting_details}}
                            </p>
                            <p class="md-body-1" v-if="registration_for_contract_needs_set && registration_enabled">
                                Sind die Daten zur Erfüllung eines Vertrages oder zur Durchführung vorvertraglicher
                                Maßnahmen erforderlich, ist eine vorzeitige Löschung der Daten nur möglich, soweit
                                nicht vertragliche oder gesetzliche Verpflichtungen einer Löschung entgegenstehen.
                            </p>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                VIII. Kontaktformular und E-Mail-Kontakt
                            </md-subheader>
                            <p class="md-body-2">
                                1. Beschreibung und Umfang der Datenverarbeitung
                            </p>
                            <p class="md-body-1">
                                Auf unserer Internetseite ist ein Kontaktformular vorhanden, welches für die
                                elektronische Kontaktaufnahme genutzt werden kann. Nimmt ein Nutzer diese Möglichkeit
                                wahr, so werden die in der Eingabemaske eingegeben Daten an uns übermittelt und
                                gespeichert. Diese Daten sind:
                            </p>
                            <ul style="list-style-type: none;" class="md-body-1">
                                <li v-for="contact_data_entry in contact_data_entries"
                                    v-bind:key="contact_data_entry">
                                    {{contact_data_entry}}
                                </li>
                            </ul>
                            <p class="md-body-1" v-if="contact_process_saved">
                                Im Zeitpunkt der Absendung der Nachricht werden zudem folgende Daten gespeichert:
                            </p>
                            <p class="md-body-1" v-else>
                                Im Zeitpunkt der Absendung der Nachricht werden keine anderen Daten gespeichert.
                            </p>
                            <ul style="list-style-type: none;" class="md-body-1" v-if="contact_process_saved">
                                <li v-for="contact_process_entry in contact_process_entries"
                                    v-bind:key="contact_process_entry">
                                    {{contact_process_entry}}
                                </li>
                            </ul>
                            <p class="md-body-1">
                                Für die Verarbeitung der Daten wird im Rahmen des Absendevorgangs Ihre Einwilligung
                                eingeholt und auf diese Datenschutzerklärung verwiesen.
                            </p>
                            <p class="md-body-1">
                                Alternativ ist eine Kontaktaufnahme über die bereitgestellte E-Mail-Adresse möglich.
                                In diesem Fall werden die mit der E-Mail übermittelten personenbezogenen Daten des
                                Nutzers gespeichert.
                            </p>
                            <p class="md-body-1" v-if="contact_only_sent_via_mail">
                                Die eingegebenen Daten werden nur per E-Mail versendet und nicht anderweitig
                                gespeichert. Eine Weitergabe der Daten an Dritte erfolgt nur auf ausdrücklichen
                                Wunsch des Nutzers oder im Rahmen gesetzlicher Vorschriften.
                            </p>
                            <p class="md-body-1" v-else>
                                Es erfolgt in diesem Zusammenhang keine Weitergabe der Daten an Dritte. Die Daten
                                werden ausschließlich für die Verarbeitung der Konversation verwendet.
                            </p>
                            <p class="md-body-2">
                                2. Rechtsgrundlage für die Datenverarbeitung
                            </p>
                            <p class="md-body-1">
                                Rechtsgrundlage für die Verarbeitung der Daten ist bei Vorliegen einer Einwilligung
                                des Nutzers Art. 6 Abs. 1 lit. a DSGVO.
                            </p>
                            <p class="md-body-1">
                                Rechtsgrundlage für die Verarbeitung der Daten, die im Zuge einer Übersendung einer
                                E-Mail übermittelt werden, ist Art. 6 Abs. 1 lit. f DSGVO. Zielt der E-Mail-Kontakt
                                auf den Abschluss eines Vertrages ab, so ist zusätzliche Rechtsgrundlage für die
                                Verarbeitung Art. 6 Abs. 1 lit. b DSGVO.
                            </p>
                            <p class="md-body-2">
                                3. Zweck der Datenverarbeitung
                            </p>
                            <p class="md-body-1">
                                Die Verarbeitung der personenbezogenen Daten aus der Eingabemaske dient uns allein
                                zur Bearbeitung der Kontaktaufnahme. Im Falle einer Kontaktaufnahme per E-Mail liegt
                                hieran auch das erforderliche berechtigte Interesse an der Verarbeitung der Daten.
                            </p>
                            <p class="md-body-1" v-if="contact_process_saved">
                                Die sonstigen während des Absendevorgangs verarbeiteten personenbezogenen Daten dienen
                                dazu, einen Missbrauch des Kontaktformulars zu verhindern und die Sicherheit unserer
                                informationstechnischen Systeme sicherzustellen.
                            </p>
                            <p class="md-body-2">
                                4. Dauer der Speicherung
                            </p>
                            <p class="md-body-1">
                                Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung
                                nicht mehr erforderlich sind. Für die personenbezogenen Daten aus der Eingabemaske des
                                Kontaktformulars und diejenigen, die per E-Mail übersandt wurden, ist dies dann der
                                Fall, wenn die jeweilige Konversation mit dem Nutzer beendet ist. Beendet ist die
                                Konversation dann, wenn sich aus den Umständen entnehmen lässt, dass der betroffene
                                Sachverhalt abschließend geklärt ist.
                            </p>
                            <p class="md-body-1" v-if="contact_process_saved">
                                Die während des Absendevorgangs zusätzlich erhobenen personenbezogenen Daten werden
                                spätestens nach einer Frist von sieben Tagen gelöscht.
                            </p>
                            <p class="md-body-2">
                                5. Widerspruchs- und Beseitigungsmöglichkeit
                            </p>
                            <p class="md-body-1">
                                Der Nutzer hat jederzeit die Möglichkeit, seine Einwilligung zur Verarbeitung der
                                personenbezogenen Daten zu widerrufen. Nimmt der Nutzer per E-Mail Kontakt mit uns auf,
                                so kann er der Speicherung seiner personenbezogenen Daten jederzeit widersprechen.
                                In einem solchen Fall kann die Konversation nicht fortgeführt werden.
                            </p>
                            <p class="md-body-1">
                                {{contact_revocations}}
                            </p>
                            <p class="md-body-1">
                                Alle personenbezogenen Daten, die im Zuge der Kontaktaufnahme gespeichert wurden,
                                werden in diesem Fall gelöscht.
                            </p>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                IX. Webanalyse {{webanalyse_tool}}
                            </md-subheader>
                            <p class="md-body-2">
                                1. Beschreibung und Umfang der Datenverarbeitung
                            </p>
                            <p class="md-body-1" v-if="webanalyse_used">
                                Wir nutzen auf unserer Website das Open-Source-Software-Tool Matomo (ehemals PIWIK) zur
                                Analyse des Surfverhaltens unserer Nutzer. Die Software setzt ein Cookie auf dem
                                Rechner der Nutzer (zu Cookies siehe bereits oben). Werden Einzelseiten unserer Website
                                aufgerufen, so werden folgende Daten gespeichert:
                            </p>
                            <p class="md-body-1" v-else>
                                Auf unserer Internetseite wird keine Webanalyse durchgeführt.
                            </p>
                            <ul style="list-style-type: none;" class="md-body-1" v-if="webanalyse_used">
                                <li v-for="webanalyse_data_entry in webanalyse_data_entries"
                                    v-bind:key="webanalyse_data_entry">
                                    {{webanalyse_data_entry}}
                                </li>
                            </ul>
                            <p class="md-body-1" v-if="webanalyse_used">
                                Die Software läuft dabei ausschließlich auf den Servern unserer Webseite. Eine
                                Speicherung der personenbezogenen Daten der Nutzer findet nur dort statt. Eine
                                Weitergabe der Daten an Dritte erfolgt nicht.
                            </p>
                            <p class="md-body-1" v-if="webanalyse_used">
                                {{webanalyse_ip_mask}}
                            </p>
                            <p class="md-body-2">
                                2. Rechtsgrundlage für die Datenverarbeitung
                            </p>
                            <p class="md-body-1" v-if="webanalyse_used">
                                Rechtsgrundlage für die Verarbeitung der personenbezogenen Daten der Nutzer ist
                                Art. 6 Abs. 1 lit. f DSGVO.
                            </p>
                            <p class="md-body-1" v-else>
                                nicht relevant
                            </p>
                            <p class="md-body-2">
                                3. Zweck der Datenverarbeitung
                            </p>
                            <p class="md-body-1" v-if="webanalyse_used">
                                Die Verarbeitung der personenbezogenen Daten der Nutzer ermöglicht uns eine Analyse
                                des Surfverhaltens unserer Nutzer. Wir sind in durch die Auswertung der gewonnen Daten
                                in der Lage, Informationen über die Nutzung der einzelnen Komponenten unserer Webseite
                                zusammenzustellen. Dies hilft uns dabei unsere Webseite und deren Nutzerfreundlichkeit
                                stetig zu verbessern. In diesen Zwecken liegt auch unser berechtigtes Interesse in der
                                Verarbeitung der Daten nach Art. 6 Abs. 1 lit. f DSGVO. Durch die Anonymisierung der
                                IP-Adresse wird dem Interesse der Nutzer an deren Schutz personenbezogener Daten
                                hinreichend Rechnung getragen.
                            </p>
                            <p class="md-body-1" v-else>
                                nicht relevant
                            </p>
                            <p class="md-body-2">
                                4. Dauer der Speicherung
                            </p>
                            <p class="md-body-1" v-if="webanalyse_used">
                                Die Daten werden gelöscht, sobald sie für unsere Aufzeichnungszwecke nicht mehr
                                benötigt werden.
                            </p>
                            <p class="md-body-1" v-if="webanalyse_used">
                                In unserem Fall ist dies nach {{webanalyse_delete_after}} der Fall.
                            </p>
                            <p class="md-body-1" v-else>
                                nicht relevant
                            </p>
                            <p class="md-body-2">
                                5. Widerspruchs- und Beseitigungsmöglichkeit
                            </p>
                            <p class="md-body-1" v-if="webanalyse_used">
                                Cookies werden auf dem Rechner des Nutzers gespeichert und von diesem an unserer Seite
                                übermittelt. Daher haben Sie als Nutzer auch die volle Kontrolle über die Verwendung
                                von Cookies. Durch eine Änderung der Einstellungen in Ihrem Internetbrowser können Sie
                                die Übertragung von Cookies deaktivieren oder einschränken. Bereits gespeicherte
                                Cookies können jederzeit gelöscht werden. Dies kann auch automatisiert erfolgen. Werden
                                Cookies für unsere Website deaktiviert, können möglicherweise nicht mehr alle
                                Funktionen der Website vollumfänglich genutzt werden.
                            </p>
                            <p class="md-body-1" v-if="webanalyse_opt_out_enabled">
                                Wir bieten unseren Nutzern auf unserer Website die Möglichkeit eines Opt-Out aus dem
                                Analyseverfahren. Hierzu müssen Sie dem entsprechenden Link folgen. Auf diese Weise
                                wird ein weiterer Cookie auf ihrem System gesetzt, der unserem System signalisiert die
                                Daten des Nutzers nicht zu speichern. Löscht der Nutzer den entsprechenden Cookie
                                zwischenzeitlich vom eigenen System, so muss er den Opt-Out-Cookie erneut setzten.
                            </p>
                            <p class="md-body-1" v-if="webanalyse_used">
                                Nähere Informationen zu den Privatsphäreeinstellungen der Matomo Software finden Sie
                                unter folgendem Link: https://matomo.org/docs/privacy/.
                            </p>
                            <p class="md-body-1" v-else>
                                nicht relevant
                            </p>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                X. Rechte der betroffenen Personen
                            </md-subheader>
                            <p class="md-body-2">
                                1. Auskunftsrecht
                            </p>
                            <p class="md-body-1">
                                Sie können von dem Verantwortlichen eine Bestätigung darüber verlangen, ob
                                personenbezogene Daten, die Sie betreffen, von uns verarbeitet werden.
                            </p>
                            <p class="md-body-1">
                                Liegt eine solche Verarbeitung vor, können Sie von dem Verantwortlichen über folgende
                                Informationen Auskunft verlangen:
                            </p>
                            <ol type="1" class="md-body-1">
                                <li>
                                    <p>
                                        die Zwecke, zu denen die personenbezogenen Daten verarbeitet werden;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        die Kategorien von personenbezogenen Daten, welche verarbeitet werden;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        die Empfänger bzw. die Kategorien von Empfängern, gegenüber denen die Sie
                                        betreffenden personenbezogenen Daten offengelegt wurden oder noch offengelegt
                                        werden;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        die geplante Dauer der Speicherung der Sie betreffenden personenbezogenen Daten
                                        oder, falls konkrete Angaben hierzu nicht möglich sind, Kriterien für die Festlegung
                                        der Speicherdauer;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        das Bestehen eines Rechts auf Berichtigung oder Löschung der Sie betreffenden
                                        personenbezogenen Daten, eines Rechts auf Einschränkung der Verarbeitung durch den
                                        Verantwortlichen oder eines Widerspruchsrechts gegen diese Verarbeitung;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        das Bestehen eines Beschwerderechts bei einer Aufsichtsbehörde;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        alle verfügbaren Informationen über die Herkunft der Daten, wenn die
                                        personenbezogenen Daten nicht bei der betroffenen Person erhoben werden;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        das Bestehen einer automatisierten Entscheidungsfindung einschließlich
                                        Profiling gemäß Art. 22 Abs. 1 und 4 DSGVO und – zumindest in diesen Fällen –
                                        aussagekräftige Informationen über die involvierte Logik sowie die Tragweite und
                                        die angestrebten Auswirkungen einer derartigen Verarbeitung für die betroffene
                                        Person.
                                    </p>
                                </li>
                            </ol>
                            <p class="md-body-1">
                                Ihnen steht das Recht zu, Auskunft darüber zu verlangen, ob die Sie betreffenden
                                personenbezogenen Daten in ein Drittland oder an eine internationale Organisation
                                übermittelt werden. In diesem Zusammenhang können Sie verlangen, über die geeigneten
                                Garantien gem. Art. 46 DSGVO im Zusammenhang mit der Übermittlung unterrichtet
                                zu werden.
                            </p>
                            <p class="md-body-1" v-if="right_restricted_by_research_purposes">
                                Dieses Auskunftsrecht kann insoweit beschränkt werden, als es voraussichtlich die
                                Verwirklichung der Forschungs- oder Statistikzwecke unmöglich macht oder ernsthaft
                                beeinträchtigt und die Beschränkung für die Erfüllung der Forschungs- oder
                                Statistikzwecke notwendig ist.
                            </p>
                            <p class="md-body-2">
                                2. Recht auf Berichtigung
                            </p>
                            <p class="md-body-1">
                                Sie haben ein Recht auf Berichtigung und/oder Vervollständigung gegenüber dem
                                Verantwortlichen, sofern die verarbeiteten personenbezogenen Daten, die Sie betreffen,
                                unrichtig oder unvollständig sind. Der Verantwortliche hat die Berichtigung
                                unverzüglich vorzunehmen.
                            </p>
                            <p class="md-body-1" v-if="right_restricted_by_research_purposes">
                                Ihr Recht auf Berichtigung kann insoweit beschränkt werden, als es voraussichtlich die
                                Verwirklichung der Forschungs- oder Statistikzwecke unmöglich macht oder ernsthaft
                                beeinträchtigt und die Beschränkung für die Erfüllung der Forschungs- oder
                                Statistikzwecke notwendig ist.
                            </p>
                            <p class="md-body-2">
                                3. Recht auf Einschränkung der Verarbeitung
                            </p>
                            <p class="md-body-1">
                                Unter den folgenden Voraussetzungen können Sie die Einschränkung der Verarbeitung der
                                Sie betreffenden personenbezogenen Daten verlangen:
                            </p>
                            <ol type="1" class="md-body-1">
                                <li>
                                    <p>
                                        wenn Sie die Richtigkeit der Sie betreffenden personenbezogenen für eine Dauer
                                        bestreiten, die es dem Verantwortlichen ermöglicht, die Richtigkeit der
                                        personenbezogenen Daten zu überprüfen;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        die Verarbeitung unrechtmäßig ist und Sie die Löschung der personenbezogenen
                                        Daten ablehnen und stattdessen die Einschränkung der Nutzung der
                                        personenbezogenen Daten verlangen;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        der Verantwortliche die personenbezogenen Daten für die Zwecke der Verarbeitung
                                        nicht länger benötigt, Sie diese jedoch zur Geltendmachung, Ausübung oder
                                        Verteidigung von Rechtsansprüchen benötigen, oder
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        wenn Sie Widerspruch gegen die Verarbeitung gemäß Art. 21 Abs. 1 DSGVO
                                        eingelegt haben und noch nicht feststeht, ob die berechtigten Gründe des
                                        Verantwortlichen gegenüber Ihren Gründen überwiegen.
                                    </p>
                                </li>
                            </ol>
                            <p class="md-body-1">
                                Wurde die Verarbeitung der Sie betreffenden personenbezogenen Daten eingeschränkt,
                                dürfen diese Daten – von ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung
                                oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen oder zum
                                Schutz der Rechte einer anderen natürlichen oder juristischen Person oder aus Gründen
                                eines wichtigen öffentlichen Interesses der Union oder eines Mitgliedstaats verarbeitet
                                werden.
                            </p>
                            <p class="md-body-1">
                                Wurde die Einschränkung der Verarbeitung nach den o.g. Voraussetzungen eingeschränkt,
                                werden Sie von dem Verantwortlichen unterrichtet bevor die Einschränkung aufgehoben
                                wird.
                            </p>
                            <p class="md-body-1" v-if="right_restricted_by_research_purposes">
                                Ihr Recht auf Einschränkung der Verarbeitung kann insoweit beschränkt werden, als es
                                voraussichtlich die Verwirklichung der Forschungs- oder Statistikzwecke unmöglich macht
                                oder ernsthaft beeinträchtigt und die Beschränkung für die Erfüllung der Forschungs-
                                oder Statistikzwecke notwendig ist.
                            </p>
                            <p class="md-body-2">
                                4. Recht auf Löschung
                            </p>
                            <p class="md-body-1">
                                a) Löschungspflicht
                            </p>
                            <p class="md-body-1">
                                Sie können von dem Verantwortlichen verlangen, dass die Sie betreffenden
                                personenbezogenen Daten unverzüglich gelöscht werden, und der Verantwortliche ist
                                verpflichtet, diese Daten unverzüglich zu löschen, sofern einer der folgenden Gründe
                                zutrifft:
                            </p>
                            <ol type="1" class="md-body-1">
                                <li>
                                    <p>
                                        Die Sie betreffenden personenbezogenen Daten sind für die Zwecke, für die sie
                                        erhoben oder auf sonstige Weise verarbeitet wurden, nicht mehr notwendig.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Sie widerrufen Ihre Einwilligung, auf die sich die Verarbeitung gem.
                                        Art. 6 Abs. 1 lit. a oder Art. 9 Abs. 2 lit. a DSGVO stützte, und es fehlt an
                                        einer anderweitigen Rechtsgrundlage für die Verarbeitung.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Sie legen gem. Art. 21 Abs. 1 DSGVO Widerspruch gegen die Verarbeitung ein und
                                        es liegen keine vorrangigen berechtigten Gründe für die Verarbeitung vor, oder
                                        Sie legen gem. Art. 21 Abs. 2 DSGVO Widerspruch gegen die Verarbeitung ein.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Die Sie betreffenden personenbezogenen Daten wurden unrechtmäßig verarbeitet.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Die Löschung der Sie betreffenden personenbezogenen Daten ist zur Erfüllung
                                        einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der
                                        Mitgliedstaaten erforderlich, dem der Verantwortliche unterliegt.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Die Sie betreffenden personenbezogenen Daten wurden in Bezug auf angebotene
                                        Dienste der Informationsgesellschaft gemäß Art. 8 Abs. 1 DSGVO erhoben.
                                    </p>
                                </li>
                            </ol>
                            <p class="md-body-1">
                                b) Information an Dritte
                            </p>
                            <p class="md-body-1">
                                Hat der Verantwortliche die Sie betreffenden personenbezogenen Daten öffentlich gemacht
                                und ist er gem. Art. 17 Abs. 1 DSGVO zu deren Löschung verpflichtet, so trifft er unter
                                Berücksichtigung der verfügbaren Technologie und der Implementierungskosten angemessene
                                Maßnahmen, auch technischer Art, um für die Datenverarbeitung Verantwortliche, die die
                                personenbezogenen Daten verarbeiten, darüber zu informieren, dass Sie als betroffene
                                Person von ihnen die Löschung aller Links zu diesen personenbezogenen Daten oder von
                                Kopien oder Replikationen dieser personenbezogenen Daten verlangt haben.
                            </p>
                            <p class="md-body-1">
                                c) Ausnahmen
                            </p>
                            <p class="md-body-1">
                                Das Recht auf Löschung besteht nicht, soweit die Verarbeitung erforderlich ist
                            </p>
                            <ol type="1" class="md-body-1">
                                <li>
                                    <p>
                                        zur Ausübung des Rechts auf freie Meinungsäußerung und Information;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        zur Erfüllung einer rechtlichen Verpflichtung, die die Verarbeitung nach dem
                                        Recht der Union oder der Mitgliedstaaten, dem der Verantwortliche unterliegt,
                                        erfordert, oder zur Wahrnehmung einer Aufgabe, die im öffentlichen Interesse
                                        liegt oder in Ausübung öffentlicher Gewalt erfolgt, die dem Verantwortlichen
                                        übertragen wurde;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        aus Gründen des öffentlichen Interesses im Bereich der öffentlichen Gesundheit
                                        gemäß Art. 9 Abs. 2 lit. h und i sowie Art. 9 Abs. 3 DSGVO;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        für im öffentlichen Interesse liegende Archivzwecke, wissenschaftliche oder
                                        historische Forschungszwecke oder für statistische Zwecke gem.
                                        Art. 89 Abs. 1 DSGVO, soweit das unter Abschnitt a) genannte Recht
                                        voraussichtlich die Verwirklichung der Ziele dieser Verarbeitung unmöglich
                                        macht oder ernsthaft beeinträchtigt, oder
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.
                                    </p>
                                </li>
                            </ol>
                            <p class="md-body-2">
                                5. Recht auf Unterrichtung
                            </p>
                            <p class="md-body-1">
                                Haben Sie das Recht auf Berichtigung, Löschung oder Einschränkung der Verarbeitung
                                gegenüber dem Verantwortlichen geltend gemacht, ist dieser verpflichtet, allen
                                Empfängern, denen die Sie betreffenden personenbezogenen Daten offengelegt wurden,
                                diese Berichtigung oder Löschung der Daten oder Einschränkung der Verarbeitung
                                mitzuteilen, es sei denn, dies erweist sich als unmöglich oder ist mit einem
                                unverhältnismäßigen Aufwand verbunden.
                            </p>
                            <p class="md-body-1">
                                Ihnen steht gegenüber dem Verantwortlichen das Recht zu, über diese Empfänger
                                unterrichtet zu werden.
                            </p>
                            <p class="md-body-2">
                                6. Recht auf Datenübertragbarkeit
                            </p>
                            <p class="md-body-1">
                                Sie haben das Recht, die Sie betreffenden personenbezogenen Daten, die Sie dem
                                Verantwortlichen bereitgestellt haben, in einem strukturierten, gängigen und
                                maschinenlesbaren Format zu erhalten. Außerdem haben Sie das Recht diese Daten einem
                                anderen Verantwortlichen ohne Behinderung durch den Verantwortlichen, dem die
                                personenbezogenen Daten bereitgestellt wurden, zu übermitteln, sofern
                            </p>
                            <ol type="1" class="md-body-1">
                                <li>
                                    <p>
                                        die Verarbeitung auf einer Einwilligung gem. Art. 6 Abs. 1 lit. a DSGVO oder
                                        Art. 9 Abs. 2 lit. a DSGVO oder auf einem Vertrag gem. Art. 6 Abs. 1 lit. b
                                        DSGVO beruht und
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        die Verarbeitung mithilfe automatisierter Verfahren erfolgt.
                                    </p>
                                </li>
                            </ol>
                            <p class="md-body-1">
                                In Ausübung dieses Rechts haben Sie ferner das Recht, zu erwirken, dass die Sie
                                betreffenden personenbezogenen Daten direkt von einem Verantwortlichen einem anderen
                                Verantwortlichen übermittelt werden, soweit dies technisch machbar ist. Freiheiten und
                                Rechte anderer Personen dürfen hierdurch nicht beeinträchtigt werden.
                            </p>
                            <p class="md-body-1">
                                Das Recht auf Datenübertragbarkeit gilt nicht für eine Verarbeitung personenbezogener
                                Daten, die für die Wahrnehmung einer Aufgabe erforderlich ist, die im öffentlichen
                                Interesse liegt oder in Ausübung öffentlicher Gewalt erfolgt, die dem Verantwortlichen
                                übertragen wurde.
                            </p>
                            <p class="md-body-2">
                                7. Widerspruchsrecht
                            </p>
                            <p class="md-body-1">
                                Sie haben das Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben,
                                jederzeit gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten, die
                                aufgrund von Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt, Widerspruch einzulegen; dies
                                gilt auch für ein auf diese Bestimmungen gestütztes Profiling.
                            </p>
                            <p class="md-body-1">
                                Der Verantwortliche verarbeitet die Sie betreffenden personenbezogenen Daten nicht mehr,
                                es sei denn, er kann zwingende schutzwürdige Gründe für die Verarbeitung nachweisen,
                                die Ihre Interessen, Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der
                                Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.
                            </p>
                            <p class="md-body-1">
                                Werden die Sie betreffenden personenbezogenen Daten verarbeitet, um Direktwerbung zu
                                betreiben, haben Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung der Sie
                                betreffenden personenbezogenen Daten zum Zwecke derartiger Werbung einzulegen; dies gilt
                                auch für das Profiling, soweit es mit solcher Direktwerbung in Verbindung steht.
                            </p>
                            <p class="md-body-1">
                                Widersprechen Sie der Verarbeitung für Zwecke der Direktwerbung, so werden die Sie
                                betreffenden personenbezogenen Daten nicht mehr für diese Zwecke verarbeitet.
                            </p>
                            <p class="md-body-1">
                                Sie haben die Möglichkeit, im Zusammenhang mit der Nutzung von Diensten der
                                Informationsgesellschaft – ungeachtet der Richtlinie 2002/58/EG – Ihr Widerspruchsrecht
                                mittels automatisierter Verfahren auszuüben, bei denen technische Spezifikationen
                                verwendet werden.
                            </p>
                            <p class="md-body-1" v-if="right_restricted_by_research_purposes">
                                Sie haben auch das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben,
                                bei der Verarbeitung Sie betreffender personenbezogener Daten, die zu wissenschaftlichen
                                oder historischen Forschungszwecken oder zu statistischen Zwecken gem.
                                Art. 89 Abs. 1 DSGVO erfolgt, dieser zu widersprechen.
                            </p>
                            <p class="md-body-1" v-if="right_restricted_by_research_purposes">
                                Ihr Widerspruchsrecht kann insoweit beschränkt werden, als es voraussichtlich die
                                Verwirklichung der Forschungs- oder Statistikzwecke unmöglich macht oder ernsthaft
                                beeinträchtigt und die Beschränkung für die Erfüllung der Forschungs- oder
                                 Statistikzwecke notwendig ist.
                            </p>
                            <p class="md-body-2">
                                8. Recht auf Widerruf der datenschutzrechtlichen Einwilligungserklärung
                            </p>
                            <p class="md-body-1">
                                Sie haben das Recht, Ihre datenschutzrechtliche Einwilligungserklärung jederzeit zu
                                widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund
                                der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.
                            </p>
                            <p class="md-body-2">
                                9. Automatisierte Entscheidung im Einzelfall einschließlich Profiling
                            </p>
                            <p class="md-body-1">
                                Sie haben das Recht, nicht einer ausschließlich auf einer automatisierten Verarbeitung –
                                einschließlich Profiling – beruhenden Entscheidung unterworfen zu werden, die Ihnen
                                gegenüber rechtliche Wirkung entfaltet oder Sie in ähnlicher Weise erheblich
                                beeinträchtigt. Dies gilt nicht, wenn die Entscheidung
                            </p>
                            <ol type="1" class="md-body-1">
                                <li>
                                    <p>
                                        für den Abschluss oder die Erfüllung eines Vertrags zwischen Ihnen und dem
                                        Verantwortlichen erforderlich ist,
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        aufgrund von Rechtsvorschriften der Union oder der Mitgliedstaaten, denen der
                                        Verantwortliche unterliegt, zulässig ist und diese Rechtsvorschriften
                                        angemessene Maßnahmen zur Wahrung Ihrer Rechte und Freiheiten sowie Ihrer
                                        berechtigten Interessen enthalten oder
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        mit Ihrer ausdrücklichen Einwilligung erfolgt.
                                    </p>
                                </li>
                            </ol>
                            <p class="md-body-1">
                                Allerdings dürfen diese Entscheidungen nicht auf besonderen Kategorien
                                personenbezogener Daten nach Art. 9 Abs. 1 DSGVO beruhen, sofern nicht
                                Art. 9 Abs. 2 lit. a oder g DSGVO gilt und angemessene Maßnahmen zum Schutz der
                                Rechte und Freiheiten sowie Ihrer berechtigten Interessen getroffen wurden.
                            </p>
                            <p class="md-body-1">
                                Hinsichtlich der in 1. und 3. genannten Fälle trifft der Verantwortliche angemessene
                                Maßnahmen, um die Rechte und Freiheiten sowie Ihre berechtigten Interessen zu wahren,
                                wozu mindestens das Recht auf Erwirkung des Eingreifens einer Person seitens des
                                Verantwortlichen, auf Darlegung des eigenen Standpunkts und auf Anfechtung der
                                Entscheidung gehört.
                            </p>
                            <p class="md-body-1">
                            </p>
                            <p class="md-body-2">
                                10. Recht auf Beschwerde bei einer Aufsichtsbehörde
                            </p>
                            <p class="md-body-1">
                                Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs
                                steht Ihnen das Recht auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem
                                Mitgliedstaat ihres Aufenthaltsorts, ihres Arbeitsplatzes oder des Orts des
                                mutmaßlichen Verstoßes, zu, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie
                                betreffenden personenbezogenen Daten gegen die DSGVO verstößt.
                            </p>
                            <p class="md-body-1">
                                Die Aufsichtsbehörde, bei der die Beschwerde eingereicht wurde, unterrichtet den
                                Beschwerdeführer über den Stand und die Ergebnisse der Beschwerde einschließlich der
                                Möglichkeit eines gerichtlichen Rechtsbehelfs nach Art. 78 DSGVO.
                            </p>
                        </div>
                    </div>
                </md-card-content>
            </md-ripple>
        </md-card>
    </div>
</template>

<script>
    export default {
        name: "Datenschutz",
        props: [ "runMode" ],
        data: () => ({
            // Dieser Teil ist entsprechend anzupassen. Nicht zutreffende Daten sind zu entfernen, fehlende zu ergänzen.
            log_infos: [
                "(1) Die IP-Adresse des Nutzers"
                // "(1) Informationen über den Browsertyp und die verwendete Version",
                // "(2) Das Betriebssystem des Nutzers",
                // "(3) Den Internet-Service-Provider des Nutzers",
                // "(4) Die IP-Adresse des Nutzers",
                // "(5) Datum und Uhrzeit des Zugriffs",
                // "(6) Websites, von denen das System des Nutzers auf unsere Internetseite gelangt",
                // "(7) Websites, die vom System des Nutzers über unsere Website aufgerufen werden"
            ],
            // log_option_1: Die Logfiles enthalten IP-Adressen oder sonstige Daten, die eine Zuordnung zu einem Nutzer
            // ermöglichen. Dies könnte beispielsweise der Fall sein, wenn der Link zur Website, von der der Nutzer auf
            // die Internetseite gelangt, oder der Link zur Website, zu der der Nutzer wechselt, personenbezogene Daten
            // enthält.
            log_option_1: true,
            // Option 2: Die Logfiles enthalten keine IP-Adressen oder sonstigen Daten, die eine Zuordnung zu einem
            // Nutzer ermöglichen.
            log_option_2: false,
            // true, falls eine Speicherung von IP-Adressen in Logfiles erfolgt; sonst false
            log_contains_ip: true,
            // true, wenn IP nur zur Erkennung und Abwehr von Angriffen gespeichert wird
            log_ip_only_for_defense: true,
            // Zur Anzeige der Dauer, bis wann Daten in Log-Dateien gelöscht werden:
            log_latest_deleting: "nach spätestens sieben Tagen",
            // Falls eine Verwendung technisch notwendiger Cookies erfolgt:
            cookies_necessary_used: false,
            // Es folgt eine Auflistung der gespeicherten Daten. Beispiele können sein:
            cookies_necessary_entries: [
                "(1) Spracheinstellungen",
                "(2) Artikel in einem Warenkorb",
                "(3) Log-In-Informationen"
            ],
            // Falls zudem eine Verwendung technisch nicht notwendiger Cookies erfolgt:
            cookies_not_necessary_used: false,
            // Es folgt eine Auflistung der erhobenen Daten. Diese können beispielsweise sein:
            cookies_not_necessary_entries: [
                "(1) Eingegebene Suchbegriffe",
                "(2) Häufigkeit von Seitenaufrufen",
                "(3) Inanspruchnahme von Website-Funktionen"
            ],
            // false: Bislang war es nach § 15 Abs. 3 TMG möglich, für technisch nicht notwendige Cookies eine
            // Pseudonymisierung der verarbeiteten personenbezogenen Daten vorzunehmen und den Nutzer über die
            // Verwendung der Cookies und sein Widerspruchs- und Beseitigungsrecht zu informieren („Opt-Out-Lösung“).
            // Es ist jedoch in der juristischen Literatur umstritten, ob diese Norm auch nach Geltung der DSGVO weiter
            // Anwendung findet. Im Zweifel muss daher davon ausgegangen werden, dass nunmehr allein die Vorschriften
            // der DSGVO gelten. In diesem Fall ist allein auf Art. 6 Abs. 1 DSGVO abzustellen. Auch nach dieser Norm
            // ist eine Fortführung der bisherigen Praxis denkbar, wenn auf ein „berechtigtes Interesse“ des
            // Verarbeitenden nach Art. 6 Abs. 1 lit. f DSGVO abgestellt wird. Falls also vor dem Setzen und Abrufen
            // der technisch nicht notwendigen Cookies keine Einwilligung des Nutzers eingeholt wird: false
            //
            // true: Ob die bisherige Praxis der „Opt-Out-Lösung“ den Anforderungen des Art. 6 Abs. 1 lit. f DGVO
            // gerecht wird, kann derzeit nicht mit Sicherheit gesagt werden. Klarheit könnte diesbezüglich die
            // geplante E-Privacy-Verordnung bringen. Bis dahin besteht die rechtssicherste Lösung allerdings darin,
            // eine vorherige Einwilligung des Nutzers einzuholen („Opt-In-Lösung“). Falls also vor dem Setzen und
            // Abrufen der technisch nicht notwendigen Cookies eine Einwilligung des Nutzers eingeholt wird: true
            cookies_not_necessary_accepted: false,
            // Es folgt eine Auflistung der Anwendungen. Beispiele können sein:
            cookies_applications: [
                "(1) Warenkorb",
                "(2) Übernahme von Spracheinstellungen",
                "(3) Merken von Suchbegriffen"
            ],
            // Der genaue Einsatzzweck der Analysecookies sollte an dieser Stelle genauer beschrieben werden.
            cookies_not_necessary_reason:
                "Test: XXXXXXXXXXXXXXXXX Wir benutzen Analysecookies, um Ihre Schuhgröße zu verkleinern. " +
                "XXXXXXXXXXXXXXXXX",
            // Falls auch Flash-Cookies eingesetzt werden:
            cookies_flash_used: false,
            // Es wird keine Newsletter-Funktion angeboten:
            newsletter_not_used: true,
            // Der Newsletter-Versand erfolgt aufgrund der Anmeldung des Nutzers auf der Website:
            newsletter_website_registering: true,
            // An dieser Stelle sollte eine konkrete Nennung der erhobenen Daten erfolgen. Im Minimalfall betrifft
            // dies die E-Mail-Adresse des Nutzers.
            newsletter_form_data_entries: [
                "(1) E-Mail-Adresse des Nutzers",
                "(2) Voller Name des Nutzers"
            ],
            // Es müssen die tatsächlich erhobenen weiteren Daten angegeben werden. Dies können beispielsweise sein:
            newsletter_registration_data_entries: [
                "(1) IP-Adresse des aufrufenden Rechners",
                "(2) Datum und Uhrzeit der Registrierung"
            ],
            // Der Newsletter-Versand erfolgt aufgrund des Verkaufs von Waren oder Dienstleistungen:
            newsletter_buying_products: false,
            // An dieser Stelle sollten die entsprechenden Daten aufgelistet werden.
            registration_data_entries: [
                "(1) E-Mail-Adresse des Nutzers",
                "(2) Voller Name des Nutzers"
            ],
            // Registrierung an der Webseite möglich:
            registration_enabled: false,
            // An dieser Stelle sind die Daten entsprechend aufzulisten. Beispiele können sein:
            registration_process_entries: [
                "(1) Die IP-Adresse des Nutzers",
                "(2) Datum und Uhrzeit der Registrierung"
            ],
            // Die Registrierung dient nicht zum Abschluss eines Vertrages mit dem Nutzer:
            registration_without_contract_set: true,
            // Es folgt eine nähere Beschreibung der Inhalte und Leistungen. Warum ist im Einzelfall eine
            // Identifikation des Nutzers für die Bereithaltung erforderlich?
            registration_without_contract_details: "Test: XXXXXXXXXXXXXXXXX " +
                "Es folgt eine nähere Beschreibung der Inhalte und Leistungen. Warum ist im Einzelfall eine " +
                "Identifikation des Nutzers für die Bereithaltung erforderlich? XXXXXXXXXXXXXXXXX",
            // Wenn die Registrierung der Erfüllung eines Vertrages, dessen Vertragspartei die betroffene Person ist,
            // oder der Durchführung vorvertraglicher Maßnahmen dient.
            registration_for_contract_needs_set: false,
            // Es folgt eine nähere Beschreibung des auf der Internetseite angebotenen Vertrages. Warum sind für diese
            // Verträge die erhobenen Daten erforderlich?
            registration_for_contract_needs_details: "Test: XXXXXXXXXXXXXXXXX Es folgt eine nähere Beschreibung des " +
                "auf der Internetseite angebotenen Vertrages. Warum sind für diese Verträge die erhobenen Daten " +
                "erforderlich? XXXXXXXXXXXXXXXXX",
            // Sollte für die von Ihnen angebotenen Verträge eine Verarbeitung der personenbezogenen Daten des
            // Vertragspartners bei Vertragsschluss gesetzlich vorgeschrieben sein, so sind die jeweiligen Normen,
            // aus denen sich die Verpflichtung ergibt, zu nennen.
            registration_for_contract_needs_laws: "Test: XXXXXXXXXXXXXXXXX Sollte für die von Ihnen angebotenen " +
                "Verträge eine Verarbeitung der personenbezogenen Daten des Vertragspartners bei Vertragsschluss " +
                "gesetzlich vorgeschrieben sein, so sind die jeweiligen Normen, aus denen sich die Verpflichtung " +
                "ergibt, zu nennen. XXXXXXXXXXXXXXXXX",
            // Dauerschuldverhältnisse erfordern die Speicherung der personenbezogenen Daten während der
            // Vertragslaufzeit. Zudem müssen Gewährleistungsfristen beachtet werden und die Speicherung von Daten für
            // steuerliche Zwecke. Welche Speicherfristen hierbei einzuhalten sind, lässt sich nicht pauschal festlegen,
            // sondern muss für die jeweils geschlossenen Verträge und Vertragsparteien im Einzelfall ermittelt werden.
            registration_for_finance_needs_laws: "Test: XXXXXXXXXXXXXXXXX Dauerschuldverhältnisse erfordern die " +
                "Speicherung der personenbezogenen Daten während der Vertragslaufzeit. Zudem müssen " +
                "Gewährleistungsfristen beachtet werden und die Speicherung von Daten für steuerliche Zwecke. Welche " +
                "Speicherfristen hierbei einzuhalten sind, lässt sich nicht pauschal festlegen, sondern muss für die " +
                "jeweils geschlossenen Verträge und Vertragsparteien im Einzelfall ermittelt werden. XXXXXXXXXXXXXXXXX",
            // Es folgt eine nähere Beschreibung, wie eine Löschung des Accounts und eine Änderung von Daten möglich
            // sind.
            registration_deleting_details: "Test: XXXXXXXXXXXXXXXXX Es folgt eine nähere Beschreibung, wie eine " +
                "Löschung des Accounts und eine Änderung von Daten möglich sind. XXXXXXXXXXXXXXXXX",
            // Es folgt eine Auflistung der Daten der Eingabemaske
            contact_data_entries: [
                "(1) Voller Name des Nutzers",
                "(2) Handy-Nummer des Nutzers (freiwillig)",
                "(3) Telefon-Nummer des Nutzers (freiwillig)",
                "(4) E-Mail-Adresse des Nutzers",
                "(5) Betreff",
                "(6) Nachricht"
            ],
            // Werden während der Verarbeitung zusätzliche Daten gespeichert
            contact_process_saved: false,
            // Es folgt eine Auflistung der entsprechenden Daten. Beispiele können sein:
            contact_process_entries: [
                "(1) Die IP-Adresse des Nutzers",
                "(2) Datum und Uhrzeit der Registrierung"
            ],
            // Erfolgt nur E-Mail-Versand der eingegebenen Daten
            contact_only_sent_via_mail: true,
            // Es folgt eine Beschreibung, auf welche Weise der Widerruf der Einwilligung und der Widerspruch der
            // Speicherung ermöglicht wird.
            contact_revocations: "Ein Wideruf zur Speicherung der personenbezogenen Daten im Zuge der " +
                "Kontaktaufnahme per Kontaktformular oder E-Mail kann durch eine E-Mail an den " +
                "Datenschutzbeauftragten erfolgen.",
                // "Test: XXXXXXXXXXXXXXXXX Es folgt eine Beschreibung, auf welche Weise der Widerruf der" +
                // "Einwilligung und der Widerspruch der Speicherung ermöglicht wird. XXXXXXXXXXXXXXXXX",
            // Tool, durch das die Webanalyse erfolgt, falls relevant - z.B. "durch Matomo (ehemals PIWIK)"
            webanalyse_tool: "",
            // true, wenn ein Webanalyse-Tool eingesetzt wird
            webanalyse_used: false,
            // Datenspeicherung zum Webseiten-Aufruf
            webanalyse_data_entries: [
                "(1) Zwei Bytes der IP-Adresse des aufrufenden Systems des Nutzers",
                "(2) Die aufgerufene Webseite",
                "(3) Die Website, von der der Nutzer auf die aufgerufene Webseite gelangt ist (Referrer)",
                "(4) Die Unterseiten, die von der aufgerufenen Webseite aus aufgerufen werden",
                "(5) Die Verweildauer auf der Webseite",
                "(6) Die Häufigkeit des Aufrufs der Webseite"
            ],
            // Anmerkung: Da keine Einwilligung der Nutzer vorliegt, sollte unbedingt die Funktion „Automatically
            // Anonymize Visitor IPs“ aktiviert sein. Hier wird davon ausgegangen, dass die IP-Adresse auf 2 Bytes
            // gekürzt wird. Nähere Informationen finden sich hier: https://matomo.org/docs/privacy/ .
            webanalyse_ip_mask: "Die Software ist so eingestellt, dass die IP-Adressen nicht vollständig gespeichert " +
                "werden, sondern 2 Bytes der IP-Adresse maskiert werden (Bsp.:  192.168.xxx.xxx). Auf diese Weise ist " +
                "eine Zuordnung der gekürzten IP-Adresse zum aufrufenden Rechner nicht mehr möglich.",
            // Hier muss der genaue Zeitpunkt der Löschung angegeben werden. Dies lässt sich in der Software einstellen
            // (siehe: https://matomo.org/docs/privacy/).
            webanalyse_delete_after: "einem Jahr",
            // Falls die Opt-Out-Option auf der Webseite angeboten wird:
            webanalyse_opt_out_enabled: false,
            // Abschnitt: Rechte betroffener Personen
            //
            // Die folgende Auflistung umfasst alle Rechte der Betroffenen nach der DSGVO. Rechte, die für die eigene
            // Webseite keine Relevanz haben, müssen nicht genannt werden. Insoweit kann die Auflistung gekürzt werden.
            //
            // Bei einer Datenverarbeitung zu wissenschaftlichen, historischen oder statistischen Forschungszwecken:
            right_restricted_by_research_purposes: false
        })
    }
</script>
<style lang="scss" scoped>
    .md-subheader {
        padding-left: 0!important;
    }
    .second-sub {
        font-weight: bold;
    }
    .table-space-right {
        width: 20px;
    }
    .table-space-middle {
        width: 100px;
    }
    .contact-table {
        margin-bottom: 12px;
    }
</style>
